const MP_API_URL = 'https://reportesmp.netizar.com/api';
// const MP_API_URL = 'http://localhost:3002/api';
// const MP_API_URL = 'https://b1ce-168-121-36-116.ngrok-free.app/api';
// const MP_API_URL_HIPER = 'https://mphipergas.netizar.com/api';
// const MP_API_URL_NATURAL = 'https://mpnatural.netizar.com/api';

export const conciliarPagos = async (data) => {  
  try {
    // const response = await fetch(`${urlMP}/reportes/conciliacion`, {
    const response = await fetch(`${MP_API_URL}/reportes/conciliacion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error en la conciliación');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error en conciliarPagos:', error);
    throw error;
  }
};

export const getPaymentsByStore = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/payments/store/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentsByStore:', error);
    throw error;
  }
};

export const getPaymentSummary = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/summary/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentSummary:', error);
    throw error;
  }
};

export const getPaymentStats = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/stats/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentStats:', error);
    throw error;
  }
};

export const getPaymentById = async (paymentId) => {
  try {
    const response = await fetch(`${MP_API_URL}/reportes/payment/${paymentId}`);
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentById:', error);
    throw error;
  }
};